import type { IconData } from '@stacksjs/iconify-core'

export const speaker2Solid: IconData = {
  "body": "<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M30 30a6 6 0 1 1-12 0a6 6 0 0 1 12 0m-6 3a3 3 0 1 0 0-6a3 3 0 0 0 0 6\"/><path d=\"M24 46.5c-5.926 0-10.206-.242-13.041-.491c-3.3-.29-5.765-2.887-5.993-6.152C4.74 36.592 4.5 31.403 4.5 24s.239-12.592.466-15.857S7.66 2.281 10.96 1.991C13.794 1.742 18.074 1.5 24 1.5s10.206.242 13.041.491c3.3.29 5.765 2.887 5.993 6.152c.227 3.265.466 8.454.466 15.857s-.239 12.592-.466 15.857s-2.693 5.862-5.993 6.152c-2.835.249-7.115.491-13.041.491m0-39a3.5 3.5 0 1 0 0 7a3.5 3.5 0 0 0 0-7m0 12c-5.799 0-10.5 4.701-10.5 10.5S18.201 40.5 24 40.5S34.5 35.799 34.5 30S29.799 19.5 24 19.5\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default speaker2Solid
